import { StafferPetProfileSprite } from "../staffer-pets/StafferPetProfileSprite";
import { Row, Text } from "@/components";
import { useInactiveUserIds } from "@/contexts/TaggableUsersContext";
import { useGetPets } from "@/hooks/queries/useGetPets";

import type { LeaderboardUser } from "@/types";

const LEADER_PET_SLOT_PX = 26;

/** A leader's name with their pet beside it. */
export const LeaderPetName = ({
  duneWormPetSizePx,
  leader,
  petSizePx = LEADER_PET_SLOT_PX,
  textClassName,
}: {
  duneWormPetSizePx?: number;
  leader: LeaderboardUser;
  petSizePx?: number;
  textClassName: string;
}) => {
  /* Database CRUD Operations */
  // Read
  const { data: pets } = useGetPets();

  /* React Hooks */
  const inactiveUserIds = useInactiveUserIds();

  /* Helpers */
  // Deactivated staffers can still be a leader if they earned revenue before
  // being deleted; flag them so it's clear they're no longer active.
  const isInactive = inactiveUserIds.has(leader.userId);
  const pet = pets?.find((entry) => entry.userId === leader.userId);
  const isLargeDuneWorm =
    pet?.equipped.petId === "DUNE_WORM" && duneWormPetSizePx !== undefined;

  /* Render */
  return (
    <Row className="min-w-0 items-center gap-1.5 overflow-visible">
      {pet ? (
        <Row
          className="relative shrink-0"
          style={{
            height: LEADER_PET_SLOT_PX,
            width: LEADER_PET_SLOT_PX,
            marginLeft: isLargeDuneWorm ? 30 : undefined,
            marginBottom: isLargeDuneWorm ? 10 : undefined,
          }}
        >
          <StafferPetProfileSprite
            pet={pet}
            sizePx={isLargeDuneWorm ? duneWormPetSizePx : petSizePx}
            className="absolute right-0 top-1/2 max-w-none -translate-y-1/2"
            isOnLeaderboard
          />
        </Row>
      ) : null}
      <Text truncate className={textClassName}>
        {leader.firstName}
      </Text>
      {isInactive && (
        <Text className="shrink-0 text-xs font-normal text-slate-400">
          (inactive)
        </Text>
      )}
    </Row>
  );
};
